<!-- AuthPage.vue -->
<template>
    <section class="conOfLogin pt-20">
      <b-tabs v-model="activeTab">
        <b-tab title="تسجيل دخول" active>
          <LoginCompanies />
        </b-tab>
        <b-tab title="سجل شركتك">
          <RegisterCompanies @registration-successful="switchToLoginTab" />
        </b-tab>
      </b-tabs>
    </section>
  </template>

  <script>
  import LoginCompanies from "./components/LoginCompanies.vue";
  import RegisterCompanies from "./components/RegisterCompanies.vue";

  export default {
    name: "AuthPage",
    components: { LoginCompanies, RegisterCompanies },
    data() {
      return {
        activeTab: 0, // Initial active tab index
      };
    },
    methods: {
      switchToLoginTab() {
        this.activeTab = 0; // Switch to the login tab
      },
    },
  };
  </script>
